export default "__VITE_ASSET__DlL1dDwT__"